import React from 'react'

function PageHeader({image, title, details}) {
  return (
    <div className="yscott-about-section mb-4">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12"> <img style={{maxHeight: 770, objectFit: 'cover', objectPosition: 'center'}} src={image} className="img-responsive" alt="" /> </div>
          <div className="col-md-12 col-sm-12 ">
            <div className="yscott-caption">
              <h2
                style={{
                  marginTop: 35,
                  fontSize: '3rem',
                }}
              >{ title }</h2>
              <p>{ details }</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PageHeader